import {
  Component, ComponentFactoryResolver, ChangeDetectorRef, OnInit, EventEmitter,
  ViewContainerRef, ViewChild, OnDestroy, AfterViewInit
} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {WizardComponent} from "../../../wizard.component";
import {UserService, ValuesExchangeProvider} from "@nrwl/common-lib";
import {Subscription} from "rxjs";
import { get, merge } from 'lodash';
import {IWizardEntry} from "../../../wizard.entry";
import {UserFromRoleComponent} from "./user.from.role.component";
import { UserFromRoleWizardService } from "./user.from.role.wizard.service";
import { UserResultsComponent } from "../user-results/user-results.component";

@Component({
  selector: "user-from-role-wizard",
  providers: [UserFromRoleWizardService],
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", '../../../wizard.button.style.scss']
})
export class RemoveUserFromRolesWizard extends WizardComponent implements OnInit, AfterViewInit, OnDestroy, IWizardEntry{
  wizardConfig: any;
  wizardId: string;
  dataId: any;
  onClose = new EventEmitter<any>();

  wizardService: UserFromRoleWizardService;
  userService: UserService;
  openWizard: any;
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;

  @ViewChild("contentPlaceholder", { read: ViewContainerRef,
static: true })
  contentRef: ViewContainerRef;

  constructor(
    wizardService: UserFromRoleWizardService,
    userService: UserService,
    changeDetectorRef: ChangeDetectorRef,
    private exchange: ValuesExchangeProvider,
    private readonly activatedRoute: ActivatedRoute,
    private readonly factoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.wizardService = wizardService;
    this.userService = userService;
    this.changeDetectorRef = changeDetectorRef;
  }

  ngOnInit() {
    this.subscription = this.activatedRoute.queryParams.subscribe((data) => {
      const defaultParams = merge({}, this.dataId, JSON.parse(get(data, 'defaultParams', "{}")));
      defaultParams['userNames'] = [defaultParams['username']];
      delete defaultParams['username'];
      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
    });
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  get(object, path: string) {
    return get(object, path);
  }

  //-------------- Control && Validation -----------------------
  toggleNext() {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack() {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleFinish() {
    const result  = this.wizardService.onFinish();
    result.subscribe((outcome) => {
      this.createContentComponent();
      this.exchange.notifyListeners('user-profile-role-group-update-done', true);
    });
  }

  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }

  toggleReOpen() {
    this.wizardService.reOpen();
  }

  getWizardService() {
    return this.wizardService;
  }

  getFactoryResolver() {
    return this.factoryResolver;
  }

  getContentViewRef() {
    return this.contentRef;
  }

  getSubContentViewRef() {
  }

  resolveComponentType(pageId: any) {
    switch (pageId) {
      case 'user.from.role.html':
        this.exchange.notifyListeners('user-profile-role-group-update-done', false);
        return UserFromRoleComponent;
      case 'user-results.html':
        return UserResultsComponent;
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }
  }
}
